<template>
    <div class="navigation navigation--sub">
        <div class="navigation__sub--wrapper container">
            <div @click="clearSearch()" class="logo__wrapper">
                <router-link v-if="$store.state.creatorPage" to="/creator">
                    <svg width="40px" height="40px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="icons-/-filled-/-layers-show" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <path d="M23.2713354,16.0378794 C23.5208781,15.927794 23.8203293,16.0378794 23.9301281,16.298081 C24.0399268,16.5482749 23.9301281,16.8485076 23.6805854,16.9585929 L23.6805854,16.9585929 L12.2016227,21.9624709 C12.0818422,22.0125097 11.9321166,22.0125097 11.8123361,21.9624709 L11.8123361,21.9624709 L0.333373407,16.9585929 C0.0738490332,16.8485076 -0.0359497405,16.5582827 0.0738490332,16.3080888 C0.185644148,16.0578949 0.473117301,15.9478096 0.732641676,16.0578949 L0.732641676,16.0578949 L12.021952,20.9747054 L23.3112622,16.0578949 Z M23.2713354,13.0255448 C23.5208781,12.9154595 23.8203293,13.0255448 23.9301281,13.2857465 C24.0399268,13.5359404 23.9301281,13.836173 23.6805854,13.9462584 L23.6805854,13.9462584 L12.2016227,18.9501364 C12.0818422,19.0001751 11.9321166,19.0001751 11.8123361,18.9501364 L11.8123361,18.9501364 L0.333373407,13.9462584 C0.0738490332,13.8441792 -0.0359497405,13.5459481 0.0738490332,13.2957542 C0.185644148,13.0455603 0.473117301,12.935475 0.732641676,13.0455603 L0.732641676,13.0455603 L12.021952,17.9713778 L23.3112622,13.0575696 Z M0.0638673265,10.2914259 C0.175662442,10.041232 0.463135595,9.93114664 0.722659969,10.041232 L0.722659969,10.041232 L12.0059812,14.9650479 L23.2952915,10.0512397 C23.5418397,9.94115439 23.8412909,10.0512397 23.9510896,10.3114414 C24.0608884,10.5616353 23.9510896,10.8618679 23.701547,10.9719533 L23.701547,10.9719533 L12.2225843,15.9758313 C12.1028038,16.02587 11.9530782,16.02587 11.8332977,15.9758313 L11.8332977,15.9758313 L11.8023544,15.9528134 C10.3587501,15.3239511 9.08748615,14.7754166 7.9686772,14.2955075 L7.08690354,13.9179304 C1.14697273,11.3787589 0.0299238523,10.9859268 3.30551558e-15,10.5409689 L0.000317435709,10.498364 C0.00256092928,10.4697619 0.00870880005,10.4406683 0.017804874,10.4105205 L0.0335406156,10.3644379 C0.0423945408,10.3409309 0.0526379064,10.3166727 0.0638673265,10.2914259 Z M11.8223178,2.0450349 C11.9420983,1.98498837 12.0918239,1.98498837 12.2215861,2.0450349 L12.2215861,2.0450349 L23.7005488,7.04891291 C24.0998171,7.22705096 24.0998171,7.78948685 23.7005488,7.96962646 L23.7005488,7.96962646 L12.2215861,12.9735045 C12.1018056,13.0235432 11.95208,13.0235432 11.8322995,12.9735045 L11.8322995,12.9735045 L0.353336821,7.96962646 L0.343355114,7.9596187 C-0.0658948607,7.78948685 -0.0658948607,7.21904476 0.343355114,7.04891291 L0.343355114,7.04891291 Z" id="Combined-Shape" fill="#69c350"></path>
                        </g>
                    </svg>
                    <span class="title">{{$t('page_title')}}</span>
                    <span class="title creator">{{$t('page_title_creator')}}</span>
                </router-link>
                <router-link v-else to="/">
                    <svg width="40px" height="40px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="icons-/-filled-/-layers-show" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <path d="M23.2713354,16.0378794 C23.5208781,15.927794 23.8203293,16.0378794 23.9301281,16.298081 C24.0399268,16.5482749 23.9301281,16.8485076 23.6805854,16.9585929 L23.6805854,16.9585929 L12.2016227,21.9624709 C12.0818422,22.0125097 11.9321166,22.0125097 11.8123361,21.9624709 L11.8123361,21.9624709 L0.333373407,16.9585929 C0.0738490332,16.8485076 -0.0359497405,16.5582827 0.0738490332,16.3080888 C0.185644148,16.0578949 0.473117301,15.9478096 0.732641676,16.0578949 L0.732641676,16.0578949 L12.021952,20.9747054 L23.3112622,16.0578949 Z M23.2713354,13.0255448 C23.5208781,12.9154595 23.8203293,13.0255448 23.9301281,13.2857465 C24.0399268,13.5359404 23.9301281,13.836173 23.6805854,13.9462584 L23.6805854,13.9462584 L12.2016227,18.9501364 C12.0818422,19.0001751 11.9321166,19.0001751 11.8123361,18.9501364 L11.8123361,18.9501364 L0.333373407,13.9462584 C0.0738490332,13.8441792 -0.0359497405,13.5459481 0.0738490332,13.2957542 C0.185644148,13.0455603 0.473117301,12.935475 0.732641676,13.0455603 L0.732641676,13.0455603 L12.021952,17.9713778 L23.3112622,13.0575696 Z M0.0638673265,10.2914259 C0.175662442,10.041232 0.463135595,9.93114664 0.722659969,10.041232 L0.722659969,10.041232 L12.0059812,14.9650479 L23.2952915,10.0512397 C23.5418397,9.94115439 23.8412909,10.0512397 23.9510896,10.3114414 C24.0608884,10.5616353 23.9510896,10.8618679 23.701547,10.9719533 L23.701547,10.9719533 L12.2225843,15.9758313 C12.1028038,16.02587 11.9530782,16.02587 11.8332977,15.9758313 L11.8332977,15.9758313 L11.8023544,15.9528134 C10.3587501,15.3239511 9.08748615,14.7754166 7.9686772,14.2955075 L7.08690354,13.9179304 C1.14697273,11.3787589 0.0299238523,10.9859268 3.30551558e-15,10.5409689 L0.000317435709,10.498364 C0.00256092928,10.4697619 0.00870880005,10.4406683 0.017804874,10.4105205 L0.0335406156,10.3644379 C0.0423945408,10.3409309 0.0526379064,10.3166727 0.0638673265,10.2914259 Z M11.8223178,2.0450349 C11.9420983,1.98498837 12.0918239,1.98498837 12.2215861,2.0450349 L12.2215861,2.0450349 L23.7005488,7.04891291 C24.0998171,7.22705096 24.0998171,7.78948685 23.7005488,7.96962646 L23.7005488,7.96962646 L12.2215861,12.9735045 C12.1018056,13.0235432 11.95208,13.0235432 11.8322995,12.9735045 L11.8322995,12.9735045 L0.353336821,7.96962646 L0.343355114,7.9596187 C-0.0658948607,7.78948685 -0.0658948607,7.21904476 0.343355114,7.04891291 L0.343355114,7.04891291 Z" id="Combined-Shape" fill="#69c350"></path>
                        </g>
                    </svg>
                    <span class="title">{{$t('page_title')}}</span>
                </router-link>
            </div>
            <div class="menu__wrapper">
                <router-link v-if="$store.state.creatorPage" class="back--link" to="/">{{ $t('header.back')}}</router-link>
                <div v-if="!$store.state.mobileFilterVisible && !$store.state.creatorPage" class="menu__wrapper--search">
                    <svg class="lupe" width="20px" height="20px" viewBox="0 0 50 50">
                        <g id="IC-Navi-Search@2x" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linejoin="round">
                            <g id="Group" transform="translate(5.500000, 5.500000)" stroke="#575C61" stroke-width="4">
                                <path d="M38.0163294,13.2229561 C38.0163294,20.5253336 32.0957508,26.4459122 24.7933733,26.4459122 C17.4909958,26.4459122 11.5704172,20.5253336 11.5704172,13.2229561 C11.5704172,5.92057859 17.4909958,-1.54543045e-13 24.7933733,-1.54543045e-13 C32.0957508,-1.54543045e-13 38.0163294,5.92057859 38.0163294,13.2229561 Z" id="Stroke-1" transform="translate(24.793373, 13.222956) scale(-1, 1) translate(-24.793373, -13.222956) "></path>
                                <line x1="4.82280882e-13" y1="22.5720819" x2="15.4444127" y2="38.0164946" id="Stroke-3" stroke-linecap="round" transform="translate(7.722206, 30.294288) scale(-1, 1) translate(-7.722206, -30.294288) "></line>
                            </g>
                        </g>
                    </svg>
                    <input v-on:input="changeSearchTerm" v-on:keyup.enter="submitSearchTerm" :value="searchTerm" type="text" :placeholder="$t('header.searchbar.placeholder')" />
                    <div @click="clearSearchTerm" class="clear__search" v-if="searchTerm !== ''">
                        <svg xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 100 100" data-v-987aa114=""><path d="M 6.3895625,6.4195626 C 93.580437,93.610437 93.580437,93.610437 93.580437,93.610437" data-v-987aa114="" style="fill: none; fill-rule: evenodd; stroke: rgb(255, 255, 255); stroke-width: 18.052; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 4; stroke-dasharray: none; stroke-opacity: 1;"></path><path d="M 6.3894001,93.6106 C 93.830213,6.4194003 93.830213,6.4194003 93.830213,6.4194003" data-v-987aa114="" style="fill: none; fill-rule: evenodd; stroke: rgb(255, 255, 255); stroke-width: 17.802; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 4; stroke-dasharray: none; stroke-opacity: 1;"></path></svg>
                    </div>
                </div>
                <div class="phone__filter--info" v-if="$store.state.mobileFilterVisible"></div>
                <div @click="toggleNavigation()" class="menu__wrapper--switch">
                    <template v-if="!$store.state.loggedIn">
                        <div class="menu__icon--line 2">&nbsp;</div>
                        <div class="menu__icon--line 2">&nbsp;</div>
                        <div class="menu__icon--line 2">&nbsp;</div>
                    </template>
                    <svg v-else width="20px" height="20px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="icons-/-filled-/-user" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <path d="M16.53,9.76 C17.33,8.99 17.27,7.327 16.62,6.76 C17.14,5.37 17.809,3.763 17.527,2.35 C17.177,0.61 14.717,2.27373675e-13 12.717,2.27373675e-13 C11.157,2.27373675e-13 9.277,0.391 8.688,1.46 C8.088,1.52 7.628,1.77 7.308,2.19 C6.438,3.36 7.028,5.16 7.458,6.72 C6.798,7.28 6.718,8.97 7.528,9.73 C7.638,11.31 8.578,12.291 9.008,12.66 L9.008,15.06 C8.578,15.21 8.168,15.36 7.774,15.51 C4.303,16.78 1.794,17.709 1.061,19.17 C0.02,21.25 -3.63797881e-12,23.356 -3.63797881e-12,23.446 C-3.63797881e-12,23.716 0.224,23.946 0.5,23.946 L23.5,23.946 C23.77,23.946 24,23.716 24,23.446 C24,23.356 23.98,21.246 22.94,19.166 C22.2,17.696 19.69,16.766 16.22,15.496 C15.82,15.346 15.4,15.196 14.98,15.036 L14.98,12.626 C15.41,12.246 16.35,11.28 16.46,9.686 L16.53,9.76 Z" id="Path" fill="#575C61"></path>
                        </g>
                    </svg>
                </div>
                <div v-if="$store.state.startPage" @click="toggleFilterVisibility()" class="mobile__menu mobile__menu--switch" :class="filterVisible()">
                    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="icons-/-filled-/-filter" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <path d="M16,16 C17.3062521,16 18.4175144,16.8348501 18.8293257,18.0000889 L23,18 C23.5522847,18 24,18.4477153 24,19 C24,19.5522847 23.5522847,20 23,20 L18.8289758,20.0009007 C18.4168852,21.1656226 17.3058822,22 16,22 C14.6941178,22 13.5831148,21.1656226 13.1710242,20.0009007 L1,20 C0.44771525,20 6.76353751e-17,19.5522847 0,19 C-6.76353751e-17,18.4477153 0.44771525,18 1,18 L13.1706743,18.0000889 C13.5824856,16.8348501 14.6937479,16 16,16 Z M16,18 C15.4477153,18 15,18.4477153 15,19 C15,19.5522847 15.4477153,20 16,20 C16.5522847,20 17,19.5522847 17,19 C17,18.4477153 16.5522847,18 16,18 Z M8,9 C9.30625206,9 10.4175144,9.8348501 10.8293257,11.0000889 L23,11 C23.5522847,11 24,11.4477153 24,12 C24,12.5522847 23.5522847,13 23,13 L10.8289758,13.0009007 C10.4168852,14.1656226 9.30588222,15 8,15 C6.69411778,15 5.58311485,14.1656226 5.17102423,13.0009007 L1,13 C0.44771525,13 6.76353751e-17,12.5522847 0,12 C-6.76353751e-17,11.4477153 0.44771525,11 1,11 L5.17067428,11.0000889 C5.58248558,9.8348501 6.69374794,9 8,9 Z M8,11 C7.44771525,11 7,11.4477153 7,12 C7,12.5522847 7.44771525,13 8,13 C8.55228475,13 9,12.5522847 9,12 C9,11.4477153 8.55228475,11 8,11 Z M16,2 C17.3062521,2 18.4175144,2.8348501 18.8293257,4.00008893 L23,4 C23.5522847,4 24,4.44771525 24,5 C24,5.55228475 23.5522847,6 23,6 L18.8289758,6.00090072 C18.4168852,7.16562257 17.3058822,8 16,8 C14.6941178,8 13.5831148,7.16562257 13.1710242,6.00090072 L1,6 C0.44771525,6 6.76353751e-17,5.55228475 0,5 C-6.76353751e-17,4.44771525 0.44771525,4 1,4 L13.1706743,4.00008893 C13.5824856,2.8348501 14.6937479,2 16,2 Z M16,4 C15.4477153,4 15,4.44771525 15,5 C15,5.55228475 15.4477153,6 16,6 C16.5522847,6 17,5.55228475 17,5 C17,4.44771525 16.5522847,4 16,4 Z" id="Combined-Shape" fill="#000000"></path>
                        </g>
                    </svg>
                </div>
                <div @clickoutside="handleFocusOut()" v-if="navigationVisible" class="menu__wrapper--menu">
                    <ul class="menu__wrapper--list">
                        <li @click="hideSubnavigation()" v-if="$store.state.loggedIn"><router-link to="/collection">{{ $t('header.navigation.collection')}}</router-link></li>
                        <li @click="hideSubnavigation()" v-if="$store.state.loggedIn"><router-link to="/creator">{{ $t('header.navigation.creator')}}</router-link></li>
                        <li v-if="$store.state.loggedIn" @click="logout"><a>{{ $t('header.navigation.logout')}}</a></li>
                        <li @click="hideSubnavigation()" v-if="!$store.state.loggedIn"><router-link to="/login">{{ $t('header.navigation.login')}}</router-link></li>
                        <li @click="hideSubnavigation()" ><router-link to="/guideline">Guideline</router-link></li>
                        <li @click="hideSubnavigation()" ><a href="https://api.library.loxone.com/files/global/WWLX-Guidline-V1-3.pdf">WWLX Guideline</a></li>
                        <li @click="hideSubnavigation()" class="line--break">&nbsp;</li>
                        <language-switcher v-if="false"></language-switcher>
                        <li class="version">
                            V{{$store.state.versionNumber}}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import LanguageSwitcher from './LanguageSwitcher.vue';
    import { logoutKeycloak } from '../keycloakService.js';

    export default {
        components: {
            LanguageSwitcher,
        },
        name: 'SubNavigation',
        emits: ['search-update'],
        data(){
            return {
                searchTerm: '',
                subbmittedSearchTerm: '',
                navigationVisible: false,
                reportOverlayVisible: false,
                bugData: null
            }
        },
        methods: {
            clearSearch() {
                this.$store.state.searchTerm = '';
                this.searchTerm = '';
                this.$store.dispatch('clearFilter');
            },
            handleFocusOut() {
                this.navigationVisible = false;
            },
            changeSearchTerm(event) {
                this.searchTerm = event.target.value;
            },
            clearSearchTerm(){
                this.searchTerm = '';
                this.submitSearchTerm();
            },
            submitSearchTerm() {
                this.$store.state.searchTerm = this.searchTerm;
                

                this.$store.dispatch('loadFilteredPlugins');
            },
            toggleNavigation() {
                this.navigationVisible = !this.navigationVisible;
            },
            logout() {
                logoutKeycloak();
                this.hideSubnavigation();
                this.$store.dispatch('logout')
                .then(() => this.$router.push('/'))
                .catch(err => console.log(err))
            },
            hideSubnavigation() {
                this.navigationVisible = false;
            },
            toggleFilterVisibility() {
                this.$store.state.mobileFilterVisible = !this.$store.state.mobileFilterVisible;
            },
            filterVisible() {
                if(this.$store.state.mobileFilterVisible) {
                    return 'active';
                }
            },
            findAncestor (el, cls) {
                if(el.classList.contains(cls)) {
                    return el;
                }
                while ((el = el.parentElement) && !el.classList.contains(cls));
                return el;
            }
        },
        mounted() {
            document.addEventListener("mouseup", e => {
                if(this.navigationVisible) {
                    if(!this.findAncestor(e.target, "menu__wrapper--menu")) {
                        this.navigationVisible = false;

                    }
                }
            })
        },
        created() {
            if(window.location.search.length > 0) {
                let entryArray = window.location.search.split('?')[1].split('&');
                for (let i = 0; i < entryArray.length; i++) {
                    let entry = entryArray[i].split('=');
                    if(entry[0] === 's') {
                        this.searchTerm = decodeURIComponent(entry[1].replace(/\+/g, '%20'));
                    }
                }
            }
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    input{
        width: 100%;
    }
    .back--link{
        color: #E73246;
        font-size: 16px;
        line-height: 40px;
        text-decoration: none;
        margin-right: 20px;
    }
    .creator {
        color: #575C61 !important;
        padding-left: 8px !important;
    }
    .navigation--sub{
        height: 64px;
        background-color: #FFFFFF;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.25);
        position: absolute;
        top: 48px;
        left: 0;
        right: 0;
    }

    .navigation__sub--wrapper{
        display: flex;
        justify-content: space-between;
    }

    .logo__wrapper a{
        font-size: 0;
        line-height: 0;
        padding: 12px 0;
        display: inline-block;
    }
    .title{
        white-space: nowrap;
        font-size: 26px;
        font-weight: bold;
        padding-left: 25px;
        display: inline-block;
        line-height: 40px;
        vertical-align: top;
        color: #000000;
    }
    .beta{
        background: #69C350;
        color: white;
        font-size: 14px;
        padding: 3px 8px;
        margin-left: 10px;
        font-weight: normal;
        vertical-align: top;
    }
    .menu__wrapper{
        display: flex;
        padding: 12px 0;
        position: relative;
        user-select: none;
    }
    .menu__wrapper--switch,
    .mobile__menu--switch{
        width: 40px;
        height: 40px;
        border: 0px solid transparent;
        border-radius: 50%;
        background-color: #EDEDED;
        padding: 10px;
        box-sizing: border-box;
        cursor: pointer;
    }
    .mobile__menu--switch{
        margin-left: 20px;
    }
    .menu__wrapper--search{
        margin-right: 20px;
        padding: 4px 0;
        position: relative;
    }
    .menu__wrapper--search svg.lupe{
        position: absolute;
        top: 10px;
        left: 8px;
    }
    .menu__wrapper--search input{
        background: #EDEDED;
        border: 0;
        height: 32px;
        border-radius: 8px;
        width: 300px;
        box-sizing: border-box;
        color: #575C61;
        outline: none !important;
        font-size: 14px;
        padding-left: 36px;
    }

    .menu__wrapper--menu{
        position: absolute;
        padding: 15px 0;
        border-radius: 8px;
        background-color: #FFFFFF;
        z-index: 99;
        box-shadow: 0px 2px 8px rgba(0,0,0,0.25);
        right: 0;
        top: 64px;
        min-width: 180px;
    }

    .menu__wrapper--menu .menu__wrapper--list{
        margin: 0;
        padding: 0;
        list-style: none;
    }

    .menu__wrapper--menu .menu__wrapper--list li{
        cursor: pointer;
    }
    .menu__wrapper--menu .menu__wrapper--list li a{
        color: #000000;
        text-decoration: none !important;
        padding: 0 15px;
        line-height: 40px;
        display: inline-block;
        width: 100%;
        box-sizing: border-box;
    }

    .menu__wrapper--menu .menu__wrapper--list li:hover{
        background-color: #EDEDED;
    }

    .menu__wrapper--menu .menu__wrapper--list li.line--break{
        height: 2px;
        background-color: #EDEDED;
        margin: 8px 0;
    }

    .menu__icon--line{
        height: 2px;
        width: 20px;
        margin-bottom: 5px;
        background-color: #575C61;
        margin: 3px 0 4px 0;
    }
    .clear__search{
        display: inline-block;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        padding: 4px;
        cursor: pointer;
        box-sizing: border-box;
        background-color: rgba(0,0,0,0.5);
        position: absolute;
        top: 11px;
        right: 8px;
        bottom: 8px;
    }
    .clear__search svg{
        vertical-align: top;
    }

    .mobile__menu{
        padding: 8px;
        box-sizing: border-box;
        cursor: pointer;
        display: none;

        &.active svg path{
            fill: #69C350;
        }

        &.mobile__menu--settings{
            margin-left: 10px;
        }
    }
    .version{
        color: grey;
        font-size: 12px;
        padding: 0 15px;
        text-align: right;
        background-color: transparent !important;
    }

    @media screen and (max-width: 500px) {
        .logo__wrapper .title{
            display: none;
        }
    }
</style>